import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertor'
})
export class ConvertorPipe implements PipeTransform {

  transform(value: any, type: string): any {
    switch (type) {
      case 'isDone':
        if (value) return 'نهایی';
        return 'معلق';
        case 'isRenewal':
        if (value) return 'تمدید';
        return 'جدید';
    }
  }

}
